import { Reveal, Label } from "@/components/Reveal";

export default function Solution() {
  return (
    <section
      id="solution"
      data-testid="solution"
      className="relative py-24 md:py-32 bg-[#111827] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-4">
          <Reveal>
            <Label>02 — La soluzione</Label>
            <h2 className="font-display font-bold text-3xl sm:text-4xl mt-5 tracking-tight leading-tight">
              Dal file <span className="text-[#F5871F]">all&apos;oggetto</span>, con metodo.
            </h2>
          </Reveal>
        </div>

        <div className="md:col-span-8 space-y-8">
          <Reveal delay={0.1}>
            <p className="font-display text-2xl md:text-3xl leading-snug tracking-tight text-white">
              Con <span className="text-[#00C8D7]">copypro3d.it</span> trasformi il tuo file STL in
              un oggetto concreto, stampato con cura e attenzione al risultato finale.
            </p>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-8 pt-4">
            <Reveal delay={0.2}>
              <p className="text-slate-400 leading-relaxed">
                Ti aiuto a realizzare prototipi, pezzi personalizzati e piccoli lotti in modo
                rapido, ordinato e senza sprechi.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="text-slate-400 leading-relaxed">
                Ascolto la tua esigenza, valuto la fattibilità e ti propongo la soluzione più
                adatta al tuo obiettivo: un partner serio per la stampa 3D FDM.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
